import { Component } from 'react';

import { Box, Heading } from '@opendoor/bricks/core';

import ContactInfo, { IContactInfoProps } from './ContactInfo';

export interface IContactsSectionProps {
  contacts: Array<IContactInfoProps>;
  title?: string;
}

class ContactsSection extends Component<IContactsSectionProps> {
  public render() {
    const { contacts, title } = this.props;
    return (
      <Box>
        <Heading size="UNSAFE_h4" as="h4" color="neutrals100">
          {title ? title : 'Your Contacts'}
        </Heading>
        {contacts.map(({ email, name, onClick, organization, phone }, index) => (
          <ContactInfo
            email={email}
            key={index}
            name={name}
            onClick={onClick}
            organization={organization}
            phone={phone}
          />
        ))}
      </Box>
    );
  }
}

export default ContactsSection;
